import React, { useEffect, useState } from 'react';
import { Button, Form, Badge, Table, Modal, Row, Col, Container, Spinner } from 'react-bootstrap';
import ModalListPicker from '../../../components/Modals/ModalListPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';
import { prepareInvoiceTemplateData, prepareInvoiceAccTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';
import { settings } from '../../settings';



export default function DGLTH_customer_invoices({ item, entity = null, data, setData, refreshData }) {

    const navigate = useNavigate();
    const [modalStatus, setModalStatus] = useState(false);
    const [modalStatusDelete, setModalStatusDelete] = useState(false);
    const [plafond, setPlafond] = useState("0");
    const [plafondList, setPlafondList] = useState([]);
    const [plafondElement, setPlafondElement] = useState(null);
    const [plafondQuantity, setPlafondQuantity] = useState(null);
    const [maxQuantity, setMaxQuantity] = useState(null);
    const [impUtilizzatoOld, setImpUtilizzatoOld] = useState(null);
    const [idPlafond, setIdPlafond] = useState(null);
    const [sdiLoading, setSdiLoading] = useState(false);
    const [sdiCheckLoading, setSdiCheckLoading] = useState(false);


    useEffect(() => {
        console.log(item)
    }, [])

    useEffect(() => {
        getMaxQuantity();
    }, [plafondElement])

    function openModal() {
        setModalStatus(true);
        getPlafond();
    }
    function closeModal() {
        setModalStatus(false);
        setPlafond("0");
        setPlafondList(null);
        setPlafondQuantity(null);
    }
    async function getPlafond() {
        let constraints = [
            { fieldName: "idCustomer", type: "value", value: item.idCustomer },
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItems('statement_intent', 1, 100, sorting, '', [], constraints);
        if (res.success === 1 && res.body.length > 0) {
            setPlafondList(res.body);
        } else if (res.body.length === 0) {
            toast.error('Nessun plafond trovato per questo cliente.', { theme: 'colored' });
        }
    }
    function getMaxQuantity() {
        if (plafondElement !== null) {
            const p = plafondList.find(item => item.id === parseInt(plafondElement));
            const rimanente = parseFloat(p.impLimite) - parseFloat(p.impUtilizzato);
            const iva = parseFloat(item.totalIva);
            setImpUtilizzatoOld(parseFloat(p.impUtilizzato));
            setIdPlafond(parseInt(p.id));
            if (iva > rimanente) {
                setMaxQuantity(rimanente);
            } else {
                setMaxQuantity(iva);
            }
        }
    }
    async function updateInvoice() {
        if (maxQuantity < parseFloat(plafondQuantity)) {
            toast.error("La quantità inserita è maggiore di quella disponibile.", { theme: 'colored' })
        } else {
            const ivaFattura = parseFloat(item.totalIva) - parseFloat(plafondQuantity);
            const totFattura = parseFloat(item.totalPrice) - parseFloat(plafondQuantity);
            var data1 = {
                plafond: parseInt(plafond),
                idPlafond: parseInt(plafondElement),
                quantityPlafond: parseFloat(plafondQuantity).toFixed(2),
                totalIva: parseFloat(ivaFattura).toFixed(2),
                totalPrice: parseFloat(totFattura).toFixed(2)
            }
            console.log(data1);
            var res = await DataManager.updateItem('customer_invoices', data1, item.id);
            console.log(res);
            if (res.success === 1) {
                const a = parseFloat(impUtilizzatoOld) + parseFloat(plafondQuantity)
                var updateDataPlafond = {
                    impUtilizzato: parseFloat(a).toFixed(2)
                }
                var resUpdatePlafond = await DataManager.updateItem('statement_intent', updateDataPlafond, idPlafond);
                console.log(resUpdatePlafond);
                toast.success('Plafond IVA aggiunto con successo.', { theme: 'colored' });
                closeModal();
            }

        }
    }
    async function unloadInvoice() {
        let constraintsOutlet = [
            { fieldName: "internalCode", type: "value", value: item.orderNumber }
        ]
        var sortingOutlet = {
            'field': 'id',
            'order': 'desc'
        }
        var resOutlet = await DataManager.searchItemsSimple('customer_order', 1, 1, sortingOutlet, '', [], constraintsOutlet);
        console.log(resOutlet)
        if (resOutlet.success === 1) {
            if (resOutlet.body[0].orderType && resOutlet.body[0].orderType.value === "OUTLET") {
                var countSuccess = 0;
                for (let i = 0; i < item.rows.length; i++) {
                    var updateBody = {
                        status: { value: "10_UNLOADED" }
                    }
                    var resUpdate = await DataManager.updateItem('customer_invoice_rows', updateBody, item.rows[i].id)
                    if (resUpdate.success === 1) {
                        countSuccess++;
                    }
                }
                if (countSuccess === item.rows.length) {
                    var updateBodyOrder = {
                        status: { value: "10_CONFIRMED" }
                    }
                    var resUpdateOrder = await DataManager.updateItem('customer_invoice', updateBodyOrder, item.id)
                    if (resUpdateOrder.success === 1) {
                        toast.success("Stato fattura aggiornato con successo!", { theme: 'colored' })
                    }
                }
            } else {
                let constraintsBlocked = [
                    { fieldName: "id", type: "value", value: item.idCustomer }
                ]
                var sortingBlocked = {
                    'field': 'id',
                    'order': 'desc'
                }
                var res = await DataManager.searchItemsSimple('customer', 1, 1, sortingBlocked, '', [], constraintsBlocked);
                if (res.body[0].isBlocked === 1) {
                    toast.error('Impossibile scaricare la merce perché il cliente ' + item.nameCustomer + " è bloccato.", { theme: 'colored' })
                } else {
                    navigate('/page/UnloadInvoiceCustomer?id=' + item.id)
                }
            }
        }

    }


    function sendEmail() {
        navigate('/page/SendDocumentEmailCustomerInvoice?id=' + item.id + '&e=customer_invoices')
    }



    function openModalDelete() {
        setModalStatusDelete(true);
    }
    function closeModalDelete() {
        setModalStatusDelete(false);
    }

    async function deleteInvoice() {
        console.log(item.id)
        var data = {
            status: { value: '0_PENDING' }
        }
        var response = await DataManager.updateItem('customer_invoices', data, item.id);
        if (response.success === 1) {
            toast.success('Fattura annullata con successo!', { theme: 'colored' })
            closeModalDelete();
            refreshData();

        } else {
            toast.error("Errore nell'annullare la fattura!", { theme: 'colored' })
        }
    }


    // Funzione helper per caricare i dati completi della fattura (usata da entrambi i tipi)
    async function loadInvoiceFullData() {
        var response = await DataManager.getItem('customer_invoices', item.id);
        if (response.success !== 1) return null;

        var v = response.body[0];
        var arrayIdRow = [];
        v.rows && v.rows.forEach(e => {
            arrayIdRow.push(e.idCustomerOrderRow);
        });

        if (arrayIdRow.length === 0) {
            return { invoice: v, rows: [], order: null, paymentConditionName: '' };
        }

        let constraints = [
            { fieldName: "id", type: "in", value: arrayIdRow.toString() }
        ];
        var sorting = { 'field': 'id', 'order': 'desc' };
        var res = await DataManager.searchItems('customer_order_rows', 1, 100, sorting, '', [], constraints);
        if (res.success !== 1 || !Array.isArray(res.body)) {
            return { invoice: v, rows: [], order: null, paymentConditionName: '' };
        }

        const enrichedRows = res.body.map(orderRow => {
            const invoiceRow = v.rows?.find(ir => ir.idCustomerOrderRow === orderRow.id);
            return {
                ...orderRow,
                discountItemModel: invoiceRow?.discountItemModel || orderRow.discountItemModel
            };
        });

        let order = null;
        let pcName = '';

        if (res.body.length > 0) {
            var resOrder = await DataManager.getItem('customer_order', res.body[0].idCustomerOrder);
            if (resOrder.success === 1 && resOrder.body.length > 0) {
                order = resOrder.body[0];

                // Risolvi nome condizione pagamento con lingua
                let paymentCondition = v.idPaymentCondition;
                if (paymentCondition) {
                    if (!paymentCondition.name) {
                        const paymentId = paymentCondition.id || paymentCondition;
                        const resPayment = await DataManager.getItem('payment_condition', paymentId);
                        if (resPayment.success === 1) {
                            paymentCondition = resPayment.body[0];
                        }
                    }
                    if (paymentCondition && paymentCondition.name) {
                        const language = order.idLanguages;
                        const code = (language && (language.codiceGestionaleEsterno || language.name || '')).toUpperCase();
                        const idLang = language && language.id;

                        pcName = paymentCondition.name || '';

                        if (code.includes('ENG') || code.includes('EN')) {
                            pcName = paymentCondition.nameEng || paymentCondition.name || '';
                        } else if (code.includes('DE')) {
                            pcName = paymentCondition.nameDeu || paymentCondition.name || '';
                        } else if (code.includes('FR')) {
                            pcName = paymentCondition.nameFra || paymentCondition.name || '';
                        } else if (code.includes('ES') || code.includes('SPA')) {
                            pcName = paymentCondition.nameSpa || paymentCondition.name || '';
                        } else if (idLang) {
                            if (idLang === 1) pcName = paymentCondition.name || '';
                            else if (idLang === 2) pcName = paymentCondition.nameEng || paymentCondition.name || '';
                            else if (idLang === 3) pcName = paymentCondition.nameDeu || paymentCondition.name || '';
                            else if (idLang === 4) pcName = paymentCondition.nameFra || paymentCondition.name || '';
                            else if (idLang === 5) pcName = paymentCondition.nameSpa || paymentCondition.name || '';
                        }
                    }
                }
            }
        }

        return { invoice: v, rows: enrichedRows, order, paymentConditionName: pcName };
    }

    async function loadPrintDataInvoice() {
        const result = await loadInvoiceFullData();
        if (!result) return null;
        return {
            fileDocument: result.invoice.fileDocument,
            templateData: prepareInvoiceTemplateData(result.invoice, result.order, result.rows, result.paymentConditionName),
            filename: 'fattura_' + result.invoice.internalCode,
            entity: 'customer_invoices',
            id: item.id
        };
    }

    async function loadPrintDataInvoiceAcc() {
        const result = await loadInvoiceFullData();
        if (!result) return null;
        return {
            fileDocument: result.invoice.fileDocument,
            templateData: prepareInvoiceAccTemplateData(result.invoice, result.order, result.rows, result.paymentConditionName),
            filename: 'fattura_acc_' + result.invoice.internalCode,
            entity: 'customer_invoices',
            id: item.id
        };
    }


    // --- SDI ---
    const sdiStatusValue = item.sdiStatus?.value || item.sdiStatus || null;

    function getSdiBadge() {
        const colorMap = {
            'da_inviare': 'secondary',
            'inviata': 'primary',
            'consegnata': 'success',
            'rifiutata': 'danger',
            'errore': 'danger',
            'non_consegnata': 'warning'
        };
        const labelMap = {
            'da_inviare': 'Da inviare',
            'inviata': 'Inviata',
            'consegnata': 'Consegnata',
            'rifiutata': 'Rifiutata',
            'errore': 'Errore',
            'non_consegnata': 'Non consegnata'
        };
        if (!sdiStatusValue) return null;
        const variant = colorMap[sdiStatusValue] || 'secondary';
        const label = labelMap[sdiStatusValue] || sdiStatusValue;
        return <Badge bg={variant} className='me-1'>{label}</Badge>;
    }

    function canSendToSdi() {
        return !sdiStatusValue || sdiStatusValue === 'errore' || sdiStatusValue === 'rifiutata';
    }

    async function sendToSdi() {
        if (sdiLoading) return;
        setSdiLoading(true);
        try {
            var res = await ApiManager.sendAuthenticatedRequest('/custom/send_electronic_invoice', { idInvoice: item.id });
            if (res.success === 1) {
                toast.success('Fattura inviata a SDI con successo!', { theme: 'colored' });
                refreshData();
            } else {
                toast.error(res.message || "Errore nell'invio a SDI.", { theme: 'colored' });
            }
        } catch (err) {
            toast.error("Errore nell'invio a SDI: " + err.message, { theme: 'colored' });
        } finally {
            setSdiLoading(false);
        }
    }

    async function checkSdiStatus() {
        if (sdiCheckLoading) return;
        setSdiCheckLoading(true);
        try {
            var res = await ApiManager.sendAuthenticatedRequest('/custom/check_invoice_sdi_status', { idInvoice: item.id });
            if (res.success === 1) {
                toast.success('Stato SDI aggiornato.', { theme: 'colored' });
                refreshData();
            } else {
                toast.error(res.message || 'Errore nel controllo stato SDI.', { theme: 'colored' });
            }
        } catch (err) {
            toast.error('Errore nel controllo stato SDI: ' + err.message, { theme: 'colored' });
        } finally {
            setSdiCheckLoading(false);
        }
    }


    const isAccompagnatoria = item.documentType?.value === 0 || item.documentType?.value === '0';

    return (
        <>
            {item.status.value === '0_PENDING' && item.plafond !== 1 ? <Button size='sm' variant='outline-primary' className='me-1' onClick={() => { openModal() }}>Plafond IVA</Button> : <></>}
            {isAccompagnatoria &&
                item.status.value === '0_PENDING' && (
                    <Button onClick={() => { unloadInvoice() }} size='sm' className='me-1' variant='success'>Scarica</Button>
                )
            }

            {isAccompagnatoria ? (
                <PrintDocxButton
                    templateKey="template_invoice_acc_customer"
                    loadData={loadPrintDataInvoiceAcc}
                />
            ) : (
                <PrintDocxButton
                    templateKey="template_invoice_customer"
                    loadData={loadPrintDataInvoice}
                />
            )}

            <Button size='sm' variant='outline-primary' className='me-1' onClick={() => { sendEmail() }}>Invia email</Button>

            {item.status.value !== "0_PENDING" ? <>
                <Button size='sm' variant='outline-danger' className='me-1' onClick={() => { openModalDelete() }}>Annulla</Button>
            </> : null}

            {/* SDI Badge */}
            {settings.fatturazione && getSdiBadge()}

            {/* Invia a SDI */}
            {settings.fatturazione && canSendToSdi() ? (
                <Button size='sm' variant='warning' className='me-1' onClick={sendToSdi} disabled={sdiLoading}>
                    {sdiLoading ? <Spinner animation="border" size="sm" className='me-1' /> : <FontAwesomeIcon icon='paper-plane' className='me-1' />}
                    Invia a SDI
                </Button>
            ) : null}

            {/* Aggiorna stato SDI */}
            {settings.fatturazione && sdiStatusValue && sdiStatusValue !== 'consegnata' && sdiStatusValue !== 'errore' && sdiStatusValue !== 'rifiutata' ? (
                <Button size='sm' variant='outline-info' className='me-1' onClick={checkSdiStatus} disabled={sdiCheckLoading}>
                    {sdiCheckLoading ? <Spinner animation="border" size="sm" className='me-1' /> : <FontAwesomeIcon icon='rotate' className='me-1' />}
                    Aggiorna stato
                </Button>
            ) : null}


            {modalStatus ? <>
                <Modal show={modalStatus} onHide={closeModal} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Plafond IVA</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col>
                                    <Form.Label>Plafond IVA?</Form.Label>
                                    <Form.Select onChange={(e) => { setPlafond(e.target.value) }}>
                                        <option>Seleziona</option>
                                        <option value="1">Si</option>
                                        <option value="0">No</option>
                                    </Form.Select>
                                </Col>
                                <Col>
                                    {plafond === "1" ? <>
                                        <Form.Label>Seleziona Plafond IVA</Form.Label>
                                        <Form.Select onChange={(e) => { setPlafondElement(e.target.value) }}>
                                            <option>Seleziona</option>
                                            {plafondList && plafondList.length > 0 && plafondList.map((el, index) => {
                                                return (<>
                                                    <option key={index} value={el.id}>{el.protocol} - {el.protocolTel} - Lim: {el.impLimite}€ - Util: {el.impUtilizzato}€</option>
                                                </>)
                                            })}
                                        </Form.Select>
                                    </> : <></>}
                                </Col>
                                <Col>
                                    {plafondElement !== null && maxQuantity !== null ? <>
                                        <Form.Label>Seleziona quantità</Form.Label>
                                        <Form.Control type="number" step="0.01" placeholder="0,00" max={maxQuantity} onChange={(e) => { setPlafondQuantity(e.target.value) }} />
                                    </> : <></>}
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>
                            Chiudi
                        </Button>
                        <Button variant="success" onClick={updateInvoice}>
                            Aggiungi
                        </Button>
                    </Modal.Footer>
                </Modal>
            </> : <></>}



            {modalStatusDelete ? <>
                <Modal show={modalStatusDelete} onHide={closeModalDelete}>
                    <Modal.Header closeButton>
                        <Modal.Title>Annulla fattura</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Sei sicuro di voler annullare la fattura?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModalDelete}>
                            No
                        </Button>
                        <Button variant="danger" onClick={deleteInvoice}>
                            Si, annulla
                        </Button>
                    </Modal.Footer>
                </Modal>
            </> : <></>}


        </>
    )
};
